// utilities
import api from '@/utilities/api'

export const getCart = ({ rootState, commit, dispatch }, payload) => {
  // endpoint returns properties for campsiteBookings and parkingBookings
  return api.request({
    method: 'get',
    endpoint: 'private/cart',
    success (response) {
      commit('setCart', response.data)
      // reload parking blackouts
      dispatch('facilities/getParkingWeek', { date: rootState.facilities.searchCriteria.date }, { root: true })
    }
  })
}

export const createCampsiteBooking = ({ rootState, commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/cart/campsiteBookings',
    payload,
    success (data) {
      // reload cart
      dispatch('getCart')
    },
    failure (data) {
      // reload cart
      dispatch('getCart')
    }
  })
}

export const deleteCampsiteBooking = ({ rootState, commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/cart/campsiteBookings',
    payload,
    success (data) {
      // reload cart
      dispatch('getCart')
    }
  })
}

export const createParkingBooking = ({ rootState, commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/cart/parkingBookings',
    payload,
    success (data) {
      // reload cart
      dispatch('getCart')
    },
    failure (data) {
      // reload cart
      dispatch('getCart')
    }
  })
}

export const deleteParkingBooking = ({ rootState, commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/cart/parkingBookings',
    payload,
    success (data) {
      // reload cart
      dispatch('getCart')
    }
  })
}

export const createGatePass = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/passes/gate',
    payload,
    success (data) {
      let notification = {
        message: 'a gate pass was added to the cart',
        severity: 'success'
      }
      dispatch('info/newNotification', notification, { root: true })
      // reload cart
      dispatch('getCart')
    }
  })
}

export const deleteGatePass = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/passes/gate/' + payload.gatePassID,
    payload,
    success (data) {
      // reload cart
      dispatch('getCart')
    }
  })
}

export const deleteCartCampsiteBookingByBlackout = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/cart/campsiteBookings',
    payload,
    success (response) {
      // reload cart
      dispatch('getCart')
    }
  })
}

export const deleteCartParkingBooking = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/cart/parkingBookings',
    payload,
    success (response) {
      // reload cart
      dispatch('getCart')
    }
  })
}

export const deleteCartGatePass = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/cart/gate',
    payload,
    success (response) {
      // reload cart
      dispatch('getCart')
    }
  })
}
export const createOtherCharge = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/otherCharges',
    payload,
    success (response) {
      // reload cart
      dispatch('getCart')
    }
  })
}
export const deleteOtherCharge = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/cart/otherCharges',
    payload,
    success (response) {
      // reload cart
      dispatch('getCart')
    }
  })
}
